import { cva } from '@agapi/ui/panda/css';
export const dividerStyles = cva({
    base: {
        border: 'none',
        margin: 0,
        padding: 0,
    },
    variants: {
        orientation: {
            horizontal: {
                width: '100%',
                height: '0',
                flex: '1',
            },
            vertical: {
                width: '0',
                height: '100%',
                display: 'inline-block',
                flex: '1',
            },
        },
    },
    defaultVariants: {
        orientation: 'horizontal',
    },
});
